import React from 'react';
import { Text, TouchableRipple } from 'react-native-paper';
import { router } from 'expo-router';
import { ArrowSquareLeft } from 'iconsax-react-native';
import { View, StyleSheet, Platform } from 'react-native';
import CircularProgress from 'react-native-circular-progress-indicator';

export default function ChartCard({isBig, title, all, today, color, page = ''}) {
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    let thisValue = today * 100 / all;
    if(isNaN(thisValue)) {
      setValue(0);
    } else {
      setValue(thisValue);
    }
  }, [])
  
  if(isBig) {
    return (
      <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={() => router.push(`/${page}`)} style={{...{elevation: 2, marginBottom: 12}, ...styles.card}}>
        <>
          <View style={styles.cardHeader}>
            <Text style={styles.cardTitle}>{title}</Text>
            <View style={styles.cardHeaderButton}>
              <Text dir="rtl" style={styles.cardHeaderButtonText}>مشاهده</Text>
              <ArrowSquareLeft
                size="24"
                color="#6c6b6a"
                variant="Outline"
              />
            </View>
          </View>
          <View style={styles.cardProgressBar}>
            <CircularProgress 
              value={value} 
              valuePrefix={Platform.OS === 'web' ? '' : '%'} 
              activeStrokeColor={color}
              progressValueColor={'#2f333c'} 
              inActiveStrokeColor={'#bfc0c5'}
              inActiveStrokeWidth={18}
              activeStrokeWidth={18}
              progressValueStyle={{ fontFamily: 'IRANSans_Medium' }}
            />
          </View>
          <View>
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <View dir="rtl" style={{ width: 16, height: 16, backgroundColor: color, borderRadius: 4, marginEnd: 8 }} />
                <Text style={{ fontSize: 14, color: '#8d8f94', direction: 'rtl' }}>آگهی‌های امروز:</Text>
              </View>
              <View>
                <Text style={{ fontSize: 14, color: '#292d39', fontFamily: 'IRANSans_Medium', direction: 'rtl' }}>{today} آگهی</Text>
              </View>
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <View dir="rtl" style={{ width: 16, height: 16, backgroundColor: '#bfc0c5', borderRadius: 4, marginEnd: 8 }} />
                <Text style={{ fontSize: 14, color: '#8d8f94', direction: 'rtl' }}>کل آگهی‌ها:</Text>
              </View>
              <View>
                <Text style={{ fontSize: 14, color: '#292d39', fontFamily: 'IRANSans_Medium', direction: 'rtl' }}>{all} آگهی</Text>
              </View>
            </View>
          </View>
        </>
      </TouchableRipple>
    );
  } else {
    return (
      <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={() => router.push(`/${page}`)} style={{...{marginBottom: 8}, ...styles.card}}>
        <>
          <View style={styles.cardHeader}>
            <Text style={styles.cardTitle}>{title}</Text>
            <View style={styles.cardHeaderButton}>
              <Text dir="rtl" style={styles.cardHeaderButtonText}>مشاهده</Text>
              <ArrowSquareLeft
                size="24"
                color="#6c6b6a"
                variant="Outline"
              />
            </View>
          </View>
          <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 8 }}>
            <CircularProgress 
              value={value} 
              radius={34}
              valuePrefix={Platform.OS === 'web' ? '' : '%'} 
              activeStrokeColor={color}
              progressValueColor={'#2f333c'} 
              inActiveStrokeColor={'#bfc0c5'}
              inActiveStrokeWidth={10}
              activeStrokeWidth={10}
              progressValueStyle={{ fontFamily: 'IRANSans_Medium', fontSize: 16 }}
            />
            <View dir="rtl" style={{ flex: 1, marginStart: 16 }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <View dir="rtl" style={{ width: 16, height: 16, backgroundColor: color, borderRadius: 4, marginEnd: 8 }} />
                  <Text style={{ fontSize: 14, color: '#8d8f94', direction: 'rtl' }}>ثبتی‌های امروز:</Text>
                </View>
                <View>
                  <Text style={{ fontSize: 14, color: '#292d39', fontFamily: 'IRANSans_Medium', direction: 'rtl' }}>{today} آگهی</Text>
                </View>
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <View dir="rtl" style={{ width: 16, height: 16, backgroundColor: '#bfc0c5', borderRadius: 4, marginEnd: 8 }} />
                  <Text style={{ fontSize: 14, color: '#8d8f94', direction: 'rtl' }}>کل ثبتی ها:</Text>
                </View>
                <View>
                  <Text style={{ fontSize: 14, color: '#292d39', fontFamily: 'IRANSans_Medium', direction: 'rtl' }}>{all} آگهی</Text>
                </View>
              </View>
            </View>
          </View>
        </>
      </TouchableRipple>
    );
  }
}

const styles = StyleSheet.create({
  card: {
    width: '100%',
    height: 'auto',
    backgroundColor: '#fff',
    borderWidth: 0.5,
    borderColor: '#BFC0C5',
    borderRadius: 8,
    overflow: 'hidden', 
    padding: 12,
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  cardTitle: {
    fontSize: 16,
    fontFamily: 'IRANSans_Medium',
    color: '#292d32',
    direction: 'rtl'
  },
  cardHeaderButton: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  cardHeaderButtonText: {
    fontSize: 12, 
    color: '#8d8f94',
    marginEnd: 6,
    direction: 'rtl',
  },
  cardProgressBar: {
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 16
  }
});